import { v4 as uuidv4 } from 'uuid';

import { Decimal } from '~/main/utils/Decimal';
import { Tip, TipRequest } from '~/renderer/store/receipt/types';

export const transformTip = (tip: TipRequest): Tip => {
  const totalAmountWithTip = new Decimal(tip.paymentTotal).isNaN()
    ? new Decimal(0)
    : new Decimal(tip.paymentTotal);

  const tippableAmount = new Decimal(tip.tippableAmount).isNaN()
    ? new Decimal(totalAmountWithTip)
    : new Decimal(tip.tippableAmount);

  const transformedTipOptions =
    (Array.isArray(tip?.tipOptions) &&
      tip.tipOptions.map(tipOption => ({
        ...tipOption,
        id: uuidv4(),
      }))) ||
    [];

  return {
    ...tip,
    tipOptions: transformedTipOptions,
    paymentTotal: totalAmountWithTip.toNumber(),
    tippableAmount: tippableAmount.toNumber(),
    enteredTip: {
      tipId: null,
      tipAmount: null,
      totalAmountWithTip: totalAmountWithTip.toNumber(),
    },
  };
};
